module.exports = __webpack_public_path__ + "static/media/pasta.4c3cf2dc.png";